
















































































































import { Vue } from "@/app"

export default Vue.extend({
  name: "StartInvesting",
  props: {
    investTarget: {
      type: Object,
      validator: (value) => {
        // Vue cannot have mutually-exclusive required props
        // As a workaround, we create investTarget prop that can house either 'loan' or 'seconary_market_entry'
        return !!value &&
          Object.keys(value).length === 1 &&
          ['loan', 'secondaryMarketEntry'].includes(Object.keys(value)[0]) &&
          typeof Object.values(value)[0] === 'object' &&
          Object.keys(Object.values(value)[0]).length > 0
      },
      default() {
        return {} // Deliberately incorrect default to trip the checks
      },
    },
  },
  // emits: ["success", "close"], // TODO this line should definitely be here?
  data() {
    return {
      validateRulesLoan: [
        (v) => parseInt(v) >= 10 || this.$t('errors.youHaveToInvestAtLeastTenEur'),
        // (v) => parseInt(v) <= this.balance || this.$t('errors.youDontHaveEnoughFunds'), // TODO this should actually perform a check
        (v) => parseInt(v) == v || this.$t('errors.investmentsShouldBeInWholeEuros'),
      ],
      validateRulesSecondaryMarketEntry: [
        // XXX: Any more rules?
        (v) => parseInt(v) > 0 || this.$t('errors.youHaveToInvestAtLeastOneCent'),
      ],
      valid: true,
      amount: null,
      confirmDialog: false,
      loading: false,
    }
  },
  computed: {
    balance: function() {
      return this.$store.state.account.balance || 0
    },
    currentInvestAccount: function() {
      return this.$store.state.account
    },
    loan() {
      return this.investTarget.loan
    },
    secondaryMarketEntry() {
      return this.investTarget.secondaryMarketEntry
    },
    toPay() {
      return (Math.ceil(this.amount * (1 + parseFloat(this.secondaryMarketEntry.premium_or_discount)) * 100) / 100).toFixed(2)
    },
  },
  methods: {
    closeInside() {
      Vue.nextTick().then(() => this.$refs.amount.focus())
    },
    close() {
      this.$emit("close")
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.loan) {
          // Primary market handling
          this.loading = true
          this.$http
            .post("/investments/", {
              investment_account: this.currentInvestAccount.id,
              loan_id: this.loan.id,
              amount: this.amount,
            })
            .then(() => {
              this.loading = false
              this.$auth.fetch()
              this.$store.commit('pushMessage', {
                icon: 'mdi-party-popper',
                text: [
                  this.$t('startInvesting.youHaveSuccessfullyInvested', {
                    amount: this.amount,
                    referenceNumber: this.loan.reference_number,
                  }),
                  ' ',
                  { text: this.$t('startInvesting.youHaveSuccessfullyInvestedLink'), to: '/account/documents' },
                  '.',
                ],
                classHint: 'successfully-invested',
              })
              this.$emit("success", this.amount)
              this.$emit("close")
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          // Secondary market handling
          this.$http
            .post("/investments/", {
              investment_account: this.currentInvestAccount.id,
              secondary_market_entry_target: this.secondaryMarketEntry.id,
              amount: this.amount,
            })
            .then((response) => {
              this.loading = false
              this.$auth.fetch()
              this.$store.commit('pushMessage', {
                icon: 'mdi-party-popper',
                text: [
                  this.$t('startInvesting.youHaveSuccessfullyInvested', {
                    amount: this.amount,
                    referenceNumber: response.data.loan.reference_number,
                  }),
                  ' ',
                  { text: this.$t('startInvesting.youHaveSuccessfullyInvestedLink'), to: '/account/documents' },
                  '.',
                ],
                classHint: 'successfully-invested',
              })
              this.$emit("success", this.amount)
              this.$emit("close")
            })
            .catch(() => {
              this.loading = false
            })
          this.$emit("close")
        }
      }
    },
  },
})
